import {MenuItem} from "./menu-item";

export class MenuItemRouteMapping {

  public static readonly availableMenuDisplayItems: MenuItem[] = [
    {
      text: 'core.navigation.home',
      link: "/home/dashboard",
      style: "",
      element: "HOME",
    },
    {
      text: 'core.navigation.grundstueck',
      link: "/grundstueck",
      style: "",
      element: "GRUNDSTUECK",
    },
    {
      text: 'core.navigation.grundbuch',
      link: "/grundbuch",
      style: "",
      element: "GRUNDBUCH",
    },
    {
      text: 'core.navigation.grundbuchgeschaeft',
      link: "/grundbuch/grundbuchgeschaeft",
      style: "",
      element: "GRUNDBUCHGESCHAEFTE",
    },
    {
      text: 'core.navigation.rechte',
      link: "/grundbuch/recht",
      style: "",
      element: "RECHTE",
    },
    {
      text: 'core.navigation.berechtigtePersonen',
      link: "/grundbuch/persongb",
      style: "",
      element: "BERECHTIGTE_PERSONEN",
    },
    {
      text: 'core.navigation.grundbuchmeldung',
      link: "/grundbuch/grundbuchmeldung",
      style: "",
      element: "GRUNDBUCHMELDUNG",
    },
    {
      text: 'core.navigation.altegrundbuchmeldung',
      link: "/grundbuch/altegrundbuchmeldung",
      style: "",
      element: "ALTE_GRUNDBUCHMELDUNGEN",
    },
    {
      text: 'core.navigation.publikation',
      link: "/grundbuch/publikation",
      style: "",
      element: "PUBLIKATION",
    },
    {
      text: 'core.navigation.vermessung',
      link: "/vermessung",
      style: "",
      element: "VERMESSUNG",
    },
    {
      text: 'core.navigation.geometergeschaeft',
      link: "/vermessung/geometergeschaeft",
      style: "",
      element: "GEOMETERGESCHAEFT",
    },
    {
      text: 'core.navigation.gebaeude',
      link: "/vermessung/gebaeude",
      style: "",
      element: "GEBAEUDE",
    },
    {
      text: 'core.navigation.gebaeudeUndWohnungsregister',
      link: "/gwr",
      style: "",
      element: "GEBAEUDE_UND_WOHNUNGSREGISTER",
    },
    {
      text: 'core.navigation.gwrGebaeude',
      link: "/gwr/gebaeude",
      style: "",
      element: "GWR_GEBAEUDE",
    },
    {
      text: 'core.navigation.gwrBauprojekte',
      link: "/gwr/bauprojekt",
      style: "",
      element: "GWR_BAUPROJEKTE",
    },
    {
      text: 'core.navigation.amtlicheBewertung',
      link: "/neskoab",
      style: "",
      element: "AMTLICHE_BEWERTUNG",
    },
    {
      text: 'core.navigation.stammdaten',
      link: "/stammdaten",
      style: "",
      element: "STAMMDATEN",
    },
    {
      text: 'core.navigation.stammpersonen',
      link: "/stammdaten/stammpersonen",
      style: "",
      element: "STAMMPERSONEN",
    },
    {
      text: 'core.navigation.gemeindeGemeindekreis',
      link: "/stammdaten/gemeinde",
      style: "",
      element: "GEMEINDE_GEMEINDEKREIS",
    },
    {
      text: 'core.navigation.system',
      link: "/system",
      style: "",
      element: "SYSTEM",
    },
    {
      text: 'core.navigation.importExport',
      link: "/system/import-export",
      style: "",
      element: "IMPORT_EXPORT",
    },
    {
      text: 'core.navigation.konfiguration',
      link: "/system/konfiguration",
      style: "",
      element: "KONFIGURATION",
    },
    {
      text: 'core.navigation.erweitertesSuchregister',
      link: "/system/erweitertes-suchregister",
      style: "",
      element: "ERWEITERTES_SUCHREGISTER",
    },
    {
      text: 'core.navigation.ech0134.empfaenger',
      link: "/system/ech0134/meldungsempfaenger",
      style: "",
      element: "ECH_0134_EMPFAENGER",
    },
    {
      text: 'core.navigation.ech0134.grundbuchmeldungen',
      link: "/grundbuch/ech0134/grundbuchmeldungen",
      style: "",
      element: "ECH_0134_GRUNDBUCHMELDUNGEN",
    },
    {
      text: 'core.navigation.home',
      link: "/home/dashboard",
      style: "",
      element: "HOME_PUBLIC",
    }
  ];

  // Konfigurierbar, erscheint nur wenn zusätzliche Menu-Items übers Gui erfasst wurden
  public static readonly unterstuetzungPublicRootItem: MenuItem = {
    text: 'core.navigation.unterstuetzungPublic',
    link: "/unterstuetzungPublic",
    style: "",
    element: "UNTERSTUETZUNG_PUBLIC",
  };

  // Konfigurierbar, erscheint nur wenn zusätzliche Menu-Items übers Gui erfasst wurden
  public static readonly unterstuetzungRootItem: MenuItem = {
    text: 'core.navigation.unterstuetzung',
    link: "/unterstuetzung",
    style: "",
    element: "UNTERSTUETZUNG",
  };
}
